import React from "react";
import { DeleteOutlined } from "@ant-design/icons";
import type { ButtonConfig } from "@ms/shared-components/containers/ContainerPanel";

export interface DetailPanelButtonParams {
  selectedOperation?: any; // 当前选中的权限
  onDelete?: () => void; // 删除处理函数
}

export const getDetailPanelButtons = (params?: DetailPanelButtonParams): ButtonConfig[] => {
  const { selectedOperation, onDelete } = params || {};
  
  // 如果没有选中权限或没有删除处理函数，不显示删除按钮
  if (!selectedOperation || !onDelete) {
    return [];
  }

  return [
    {
      key: "delete",
      text: "删除",
      type: "default",
      icon: React.createElement(DeleteOutlined),
      onClick: onDelete,
      group: "primary",
      danger: true,
    },
  ];
};


